export const COLOR_PICKER_RECENT_PALETTE = "colorPicker.recentPalette";
export const ICON_EDITOR_PREVIEW_TOKEN = "iconEditorPreview.token";
export const ICON_DOWNLOAD_SIZE = "iconDownload.size";
